import { Injectable, Injector } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
  Router,
} from "@angular/router";
import { PermissionService } from "./permission.service";
import { MessageService } from '@doc/api/server-bo';
import { AuthenticationService } from "./authentication.service";
import { AccessPermissionService } from "./access-permission.service";
import { Location } from "@angular/common";
import { query } from "@angular/animations";

@Injectable({
  providedIn: "root",
})
export class PermissionGuard implements CanActivate {
  constructor(
    private injector: Injector,
    private authService: AuthenticationService,
    private messageService: MessageService,
    private location: Location,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const permissionService = this.injector.get(AccessPermissionService);
    const permission = route.data["permission"] as string;
    const multiplePermission = route.data['permissions'] as string[];
    const finalPermission = permission ? permission : multiplePermission

    const permissions = permissionService.getPermission();
    const hasDashboardPermission = permissions.some((p: any) => {
      (p.permissionName === "PRESIDENTS_DASHBOARD") ||
        (p.permissionName === "MANAGERS_DASHBOARD") ||
        (p.permissionName === "ICDDEPTS_DASHBOARD")
    });

    const isDashboardRoute =
      state.url.includes("Dashboard/President") ||
      state.url.includes("Dashboard/Departments") ||
      state.url.includes("Dashboard/ICDDepartment");
    const isRedirectTarget = state.url.includes("/main/home");

    console.log("User permissions:", permissions);

    if (hasDashboardPermission && !isDashboardRoute && !isRedirectTarget) {
      this.router.navigate(["/main/home"], {
        queryParams: { inbox: "personal" },
      });
      return false;
    }

    if (permission ? permissionService.hasPermission(permission) : permissionService.hasMultiplePermission(multiplePermission)) {
      return true;
    } else {
      if (!hasDashboardPermission && isDashboardRoute) {
        this.location.back();
      }
      return false;
    }
  }
}
